/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportPersonalAssetsResultDto
 */
export interface ImportPersonalAssetsResultDto {
    /**
     * 
     * @type {number}
     * @memberof ImportPersonalAssetsResultDto
     */
    totalRowsCount: number;
    /**
     * 
     * @type {number}
     * @memberof ImportPersonalAssetsResultDto
     */
    skippedRowsCount: number;
    /**
     * 
     * @type {number}
     * @memberof ImportPersonalAssetsResultDto
     */
    invalidRowDates: number;
    /**
     * 
     * @type {boolean}
     * @memberof ImportPersonalAssetsResultDto
     */
    invalidFormat?: boolean;
}

export function ImportPersonalAssetsResultDtoFromJSON(json: any): ImportPersonalAssetsResultDto {
    return ImportPersonalAssetsResultDtoFromJSONTyped(json, false);
}

export function ImportPersonalAssetsResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportPersonalAssetsResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalRowsCount': json['totalRowsCount'],
        'skippedRowsCount': json['skippedRowsCount'],
        'invalidRowDates': json['invalidRowDates'],
        'invalidFormat': !exists(json, 'invalidFormat') ? undefined : json['invalidFormat'],
    };
}

export function ImportPersonalAssetsResultDtoToJSON(value?: ImportPersonalAssetsResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalRowsCount': value.totalRowsCount,
        'skippedRowsCount': value.skippedRowsCount,
        'invalidRowDates': value.invalidRowDates,
        'invalidFormat': value.invalidFormat,
    };
}

